import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/shared/ui/input';

export interface SelectorPickerToolbarProps {
  query: string;
  onQueryChange: (query: string) => void;
  totalCount: number;
  pickedCount: number;
  searchPlaceholder?: string;
  /** Doménové filtry mezi search a souhrnem (jen pick modal). */
  renderPickToolbar?: ComponentType;
}

export function SelectorPickerToolbar({
  query,
  onQueryChange,
  totalCount,
  pickedCount,
  searchPlaceholder,
  renderPickToolbar: PickToolbar,
}: SelectorPickerToolbarProps) {
  const { t } = useTranslation('asyncSelector');
  const placeholder = searchPlaceholder ?? t('pickModal.searchPlaceholder');

  return (
    <div className="gap-phx-4 flex w-full items-center" data-testid="selector-picker-toolbar">
      <div className="w-full max-w-xs min-w-0 shrink-0">
        <Input
          size="md"
          leadingIcon="search"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder={placeholder}
          className="w-full"
          aria-label={placeholder}
        />
      </div>
      {PickToolbar ? (
        <div
          className="flex min-w-0 shrink-0 items-center"
          data-testid="selector-pick-toolbar-slot"
        >
          <PickToolbar />
        </div>
      ) : null}
      <p
        className="text-phx-sm text-phx-text-muted ml-auto shrink-0 text-right whitespace-nowrap"
        data-testid="selector-picker-summary"
      >
        {t('pickModal.resultsSummary', { results: totalCount, picked: pickedCount })}
      </p>
    </div>
  );
}
